import {axiosGetHandler, axiosPostHandler} from './config'
import {extractAPIValues} from '_lib/utils/utils'
const {BASE_XHH} = extractAPIValues()

export function logout (args) {
	let url = BASE_XHH + '/account/logout'
	return axiosGetHandler(url, args)
}

export function getWechatQRCodeUrl (args) {
	let url = BASE_XHH + '/account/wechat/login/v2/heybox_chat/'
	return axiosGetHandler(url, args)
}

export function getPermission (args) {
	let url = BASE_XHH + '/bbs/app/api/user/permission'
	return axiosGetHandler(url, args)
}
// 验证码登录
export function codeLogin (args, formdata) {
	let url = BASE_XHH + '/account/login_code/'
	return axiosPostHandler(url, args, formdata)
}
// 密码登录
export function pswLogin (args, formdata) {
	let url = BASE_XHH + '/account/login/'
	return axiosPostHandler(url, args, formdata)
}
// 获取验证码
export function sendCode (args, formdata) {
	let url = BASE_XHH + '/account/get_login_code/'
	return axiosPostHandler(url, args, formdata)
}
// 扫码登录
export function getLoginQrCode (args) {
	let url = BASE_XHH + '/account/heychat/get_qr/'
	return axiosGetHandler(url, args)
}
// 扫码登录检查状态
export function getLoginQrCodeState (args) {
	let url = BASE_XHH + '/account/qr_state/'
	return axiosGetHandler(url, args)
}

// token获取登录态
export function getPkeyWithToken (args) {
	let url = BASE_XHH + '/account/web_login_with_token/'
	return axiosGetHandler(url, args)
}